class DecadeNav extends window.BAO.CustomElement() {
  connectedCallback () {
    super.connectedCallback()

    if (!this._moved) {
      this._moved = true
      document.body.appendChild(this)
      return
    }

    if (this?.els?.current?.exists) {
      this.els.current.element.scrollIntoView({
        behavior: 'smooth',
        block: 'nearest',
        inline: 'center',
      })
    }
  }
}

if (!customElements.get('decade-nav')) {
  customElements.define('decade-nav', DecadeNav)
}
